var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { styled } from 'goober';
import React, { forwardRef, useRef, useState } from 'react';
var SwitchThumb = styled('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n"], ["\n    margin: 0px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n"])));
var SwitchTrack = styled('div')(function (_a) {
    var theme = _a.theme, _b = _a.$checked, $checked = _b === void 0 ? false : _b, _c = _a.$disabled, $disabled = _c === void 0 ? false : _c, _d = _a.$focused, $focused = _d === void 0 ? false : _d, _e = _a.$color, $color = _e === void 0 ? 'primary' : _e;
    var disabledColor = theme.colors.neutral.w700;
    var style = $checked
        ? {
            backgroundColor: $disabled ? disabledColor : theme.colors[$color].w500,
            borderColor: $disabled ? disabledColor : theme.colors[$color].w500,
            '&:hover': $disabled
                ? undefined
                : {
                    backgroundColor: theme.colors[$color].w700,
                    borderColor: theme.colors[$color].w700,
                },
            '&:active': $disabled
                ? undefined
                : {
                    backgroundColor: theme.colors[$color].w900,
                    borderColor: theme.colors[$color].w900,
                },
            '& > span': {
                backgroundColor: theme.colors.ui.white,
            },
        }
        : {
            backgroundColor: theme.colors.ui.white,
            borderColor: $disabled ? disabledColor : theme.colors.ui.dark,
            '&:hover': $disabled
                ? undefined
                : {
                    backgroundColor: theme.colors.neutral.w200,
                },
            '&:active': $disabled
                ? undefined
                : {
                    backgroundColor: theme.colors.neutral.w500,
                },
            '& > span': {
                backgroundColor: $disabled ? disabledColor : theme.colors.ui.dark,
            },
        };
    return __assign({ position: 'relative', margin: '0px', width: '24px', height: '12px', display: 'flex', alignItems: 'center', justifyContent: $checked ? 'flex-end' : 'flex-start', padding: '3px', transition: '.2s', borderRadius: '100px', boxSizing: 'border-box', cursor: $disabled ? 'not-allowed' : 'pointer', userSelect: 'none', outlineStyle: $focused && !$disabled ? 'solid' : 'none', outlineColor: theme.colors.ui.dark, outlineWidth: '1px', borderWidth: '1px', borderStyle: 'solid' }, style);
});
var SwitchInput = styled('input', forwardRef)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    overflow: hidden;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    bottom: 0px;\n    right: 0px;\n"], ["\n    border: 0;\n    clip: rect(0 0 0 0);\n    overflow: hidden;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    bottom: 0px;\n    right: 0px;\n"])));
var FSSwitch = forwardRef(function (props, ref) {
    var _a = __read(useState(false), 2), focus = _a[0], setFocus = _a[1];
    var inputRef = useRef();
    var _b = props.checked, checked = _b === void 0 ? false : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.style, style = _d === void 0 ? {} : _d, className = props.className, onBlur = props.onBlur, onFocus = props.onFocus, rest = __rest(props, ["checked", "disabled", "style", "className", "onBlur", "onFocus"]);
    function handleClick(event) {
        if (disabled) {
            return;
        }
        if (event.target !== inputRef.current && inputRef.current) {
            event.preventDefault();
            inputRef.current.click();
            return;
        }
    }
    function handleMouseDown(event) {
        if (disabled) {
            return;
        }
        if (event.target !== inputRef.current && inputRef.current) {
            event.preventDefault();
            inputRef.current.focus({ preventScroll: true });
            return;
        }
    }
    function handleBlur(event) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        setFocus(false);
    }
    function handleFocus(event) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        setFocus(true);
    }
    function initRefs(instance) {
        inputRef.current = instance;
        if (typeof ref === 'function') {
            ref(instance);
        }
        if (typeof ref === 'object' && ref !== null) {
            ref.current = instance;
        }
    }
    return (React.createElement(SwitchTrack, { style: style, className: className, "$checked": checked, "$disabled": disabled, "$focused": focus, onClick: handleClick, onMouseDown: handleMouseDown },
        React.createElement(SwitchThumb, null),
        React.createElement(SwitchInput, __assign({}, rest, { ref: initRefs, type: "checkbox", checked: checked, disabled: disabled, onFocus: handleFocus, onBlur: handleBlur }))));
});
export default FSSwitch;
var templateObject_1, templateObject_2;
